export default "__VITE_ASSET__c6ffdb0d__"